import React from "react";
import styled from "@emotion/styled";

import { Package } from "@/services/UserService";
import PackageCard from "@/features/user/PackageCard";

const StyledItemsContainer = styled.ul`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  img {
    border-radius: 2rem;
    object-fit: cover;
  }

  & > * {
    margin-top: 3rem;
  }
`;

const PackageDisplay: React.FC<{
  packages: Package[];
  className?: string;
}> = ({ packages, className }) => {
  return (
    <StyledItemsContainer className={className}>
      {packages.map((packageDetails, i) => (
        <li key={i}>
          <PackageCard package={packageDetails} />
        </li>
      ))}
    </StyledItemsContainer>
  );
};

export default PackageDisplay;
